module.exports = __webpack_public_path__ + "img/1.faa82f78.png";